export enum TableDataType {
    DateTime,
    String,
    Currency,
    Number,
    ReactNode,
}
